import { isBefore } from '@/utils/libs/date-fns/compare';
import { isRequiredText, strMax } from '../../../utils';
export const rfpOrderValidate = {
    reason: [strMax(2000, '2000文字以内で入力してください')],
    select: [isRequiredText('必須です')],
    tentativeEndDate: [
        isRequiredText('終了日は必須です'),
        (value, record) => {
            const tentativeStartDate = record[`start_date_${record.select}`];
            return isBefore(value, tentativeStartDate)
                ? '終了日は開始日以降を選択してください'
                : '';
        },
    ],
    tentativeStartDate: [isRequiredText('開始日は必須です')],
};
export default rfpOrderValidate;
